import { motion } from "framer-motion";
import { useSectionTracking } from "./AnalyticsProvider";
import { useLanguage } from "./LanguageProvider";

export default function HeroSection() {
  const sectionRef = useSectionTracking("hero");
  const { t } = useLanguage();
  const h = t.hero;

  return (
    <section id="top" ref={sectionRef} className="relative h-screen flex items-end overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 overflow-hidden bg-[#111110]">
        <motion.img
          src="/media/photos/hero_main2.jpg"
          alt="The Bridgette Emerald"
          initial={{ scale: 1, opacity: 0 }}
          animate={{ scale: 1.15, opacity: 1 }}
          transition={{ duration: 3, ease: "easeOut" }}
          className="w-full h-full object-cover object-[50%_55%]"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-[#111110] via-[#111110]/30 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#111110]/70 via-[#111110]/20 to-transparent" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pb-16 sm:pb-20 lg:pb-28">
        {/* Overline fades in first */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.8 }}
          className="overline mb-4 sm:mb-5"
        >
          {h.overline}
        </motion.p>

        {/* Title — each word staggers in */}
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-tighter leading-[1.05] text-[#F4F0EA] mb-6 max-w-3xl overflow-visible">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.2 }}
            className="inline"
          >
            {h.the}
          </motion.span>{" "}
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.5 }}
            className="inline italic gold-gradient-text"
          >
            {h.bridgette}
          </motion.span>{" "}
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.8 }}
            className="inline"
          >
            {h.emerald}
          </motion.span>
        </h1>

        {/* Subtitle fades in after title */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 2.3 }}
          className="text-base sm:text-lg text-[#B8B3AA] mb-8 max-w-lg font-light"
        >
          {h.subtitle}. {h.origin}.
        </motion.p>

        {/* CTA slides up last — scroll to specimen */}
        <motion.a
          href="#specimen"
          data-testid="hero-cta"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 2.8 }}
          className="inline-block px-10 py-4 bg-[#C5A059] text-[#111110] font-sans text-sm tracking-[0.15em] uppercase font-medium hover:bg-[#E8D5A3] transition-colors duration-500"
        >
          View the Specimen
        </motion.a>
      </div>
    </section>
  );
}
